import { render } from "./WifiSet.vue?vue&type=template&id=944b4640&scoped=true"
import script from "./WifiSet.vue?vue&type=script&lang=js"
export * from "./WifiSet.vue?vue&type=script&lang=js"

import "./WifiSet.vue?vue&type=style&index=0&id=944b4640&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944b4640"]])

export default __exports__